import { render } from "./OrganizationTreeNode.vue?vue&type=template&id=c04ccc64&scoped=true"
import script from "./OrganizationTreeNode.vue?vue&type=script&lang=js"
export * from "./OrganizationTreeNode.vue?vue&type=script&lang=js"

import "./OrganizationTreeNode.vue?vue&type=style&index=0&id=c04ccc64&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c04ccc64"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBadge});
